import { render, staticRenderFns } from "./VideoElement.vue?vue&type=template&id=6ce41266&scoped=true&"
import script from "./VideoElement.vue?vue&type=script&lang=js&"
export * from "./VideoElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ce41266",
  null
  
)

export default component.exports